import {dateFromStr, dateFromYearMonthDay, formatDate, TimeCalculator} from "../../common/time/TimeCalculator";
import * as $ from "jquery";
import '/modules/common/css/timeseries/simplifiedFixedInnerDatePicker.css';
import '/modules/common/css/timeseries/simplifiedFixedInnerDatePicker.responsive.css';
import {DatePicker} from "../../common/timeseries/DatePicker";
import {Dropdown, DropdownOption} from "../../common/ui/Dropdown";

/**
 * A date picker with a fixed until date and suitable to be included in a container with some other purpose
 * @extends DatePicker
 */
class SimplifiedFixedInnerDatePicker extends DatePicker {

    /**
     *
     * @param id {string} The HTML id for this container
     * @param translator {Translator} A translator
     * @param layer {Layer}
     * @param until {Date}
     * @param from {Date}
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     **/
    constructor(id, translator, layer, until, from, isMobileDevice) {
        super(id, translator, [layer], undefined, undefined, undefined, isMobileDevice);
        const timeCalculator = new TimeCalculator(
            layer.getTimeCalculator().getPeriodicity(),
            formatDate(layer.getTimeCalculator().max(layer.getDataFrom(),layer.getTimeCalculator().addDays(until,-DatePicker.MAX_DAYS))),
            formatDate(layer.getDataUntil()),
            this.translator
        );
        this.maxUntil = timeCalculator.getUntil();
        this.until = timeCalculator.min(this.maxUntil,until);
        this.minFrom = timeCalculator.getFrom();
        this.from = timeCalculator.fixDate(
            from
                ? timeCalculator.max(from,timeCalculator.getFrom())
                : timeCalculator.max(timeCalculator.getFrom(),timeCalculator.addDays(this.until, -365))
        );
        this.timeCalculator = new TimeCalculator(
            layer.getTimeCalculator().getPeriodicity(),
            formatDate(this.minFrom),
            formatDate(this.until),
            this.translator
        );
        this.setDefaultFromUntil(this.from, this.until);
    }

    getClassName() {
        return "SimplifiedFixedInnerDatePicker";
    }

    setDefaultFromUntil(from, until) {
        this.from = from;
        this.until = until;
    }

    getFrom() {
        return formatDate(this.from);
    }

    _setFrom(year, month, day) {
        this.from = dateFromYearMonthDay(year, month, day);
        this.onChangeCallbacks.forEach(c => c(this));
    }

    getUntil() {
        return formatDate(this.until);
    }

    _setUntil(year, month, day) {
        this.until = dateFromYearMonthDay(year, month, day);
        this.onChangeCallbacks.forEach(c => c(this));
    }

    _getMinUntil() {
        return this.until;
    }

    _getHardMaxUntil() {
        if (this.maxUntil)
            return this.maxUntil;
        return super._getHardMaxUntil();
    }

    _getMaxFrom() {
        return this.from;
    }

    _getHardMinFrom() {
        return this.minFrom;
    }


    getUIElement() {
        if (!this.uiElement) {
            this.uiElement = $('<div></div>');
            this.uiElement.append(this.getContainerElement());
        }
        return this.uiElement;
    }

    getContainerElement() {
        const container = $(
            '<div class="date-picker simplified-date-picker">' +
            '   <div>' +
            '       <div class="time-container from-container">' +
            '           <label for="from_datepicker_dropdown_select" class="from">' + this.translator.translate('tool.charts.from.title') + '</label>' +
            '           <div class="input-container"></div>' +
            '       </div>' +
            '       <div class="time-container until-container">' +
            '           <label class="until">' + this.translator.translate('tool.charts.until.title') + '</label>' +
            '           <div class="until-input-container"><div class="value">'+formatDate(this.timeCalculator.fixDateUntil(this.until))+'</div></div>' +
            '       </div>' +
            '   </div>' +
            '</div>'
        );

        const checkFromButtons = (fromDate) => {
            const previousButton = $('button.previous-button.from', container);
            const nextButton = $('button.next-button.from', container);
            const nextDate = this.timeCalculator.getNextDate(fromDate);
            const previousDate = this.timeCalculator.getPreviousDate(fromDate);
            if (previousDate < this.minFrom)
                previousButton.attr('disabled', 'disabled').addClass('disabled');
            else previousButton.removeAttr('disabled').removeClass('disabled');
            if (nextDate >= this.until)
                nextButton.attr('disabled', 'disabled').addClass('disabled');
            else nextButton.removeAttr('disabled').removeClass('disabled');
        };

        const setDropDownValue = (previous, dropdown) => {
            const date = dateFromStr(dropdown.getValue());
            let newDate = previous
                ? this.timeCalculator.fixDate(this.timeCalculator.getPreviousDate(date))
                : this.timeCalculator.fixDate(this.timeCalculator.getNextDate(date));
            dropdown.setValue(formatDate(newDate));
        }

        const generateInputUI = () => {
            const previousButton = $('<button title="' + this.translator.translate('tool.charts.time.previous') + '" class="previous-button from"></button>');
            const nextButton = $('<button title="' + this.translator.translate('tool.charts.time.next') + '" class="next-button from"></button>');

            let currDate = this.timeCalculator.fixDate(this.timeCalculator.getPreviousDate(this.until));
            const options = [new DropdownOption(this.translator, this.isMobileDevice, '#' + formatDate(currDate), formatDate(currDate), undefined)];
            do {
                currDate = this.timeCalculator.fixDate(this.timeCalculator.getPreviousDate(currDate));
                options.push(new DropdownOption(this.translator, this.isMobileDevice, '#' + formatDate(currDate), formatDate(currDate), undefined));
            } while (currDate > this.minFrom);
            options.reverse();
            const onChangeDropdown = (dropDown) => {
                const date = dateFromStr(dropDown.getValue());
                this._setFrom(this.timeCalculator.getYearFromDate(date), this.timeCalculator.getMonthFromDate(date), this.timeCalculator.getDayFromDate(date));
            };
            const dropdown = new Dropdown(
                this.translator,
                this.isMobileDevice,
                "from_datepicker_dropdown",
                options,
                this.getFrom(),
                true,
                'tool.charts.from.title',
                onChangeDropdown, undefined);
            $('.input-container', container).append(previousButton).append(dropdown.getUIElement()).append(nextButton);

            const onChangePicker = (picker) => {
                const fromDate = dateFromStr(picker.getFrom());
                checkFromButtons(fromDate);
            };
            onChangePicker(this);
            this.onChange(onChangePicker);

            previousButton.click(() => {
                setDropDownValue(true, dropdown);
                this.logStat('PREVIOUS_PERIOD {'+dropdown.getValue()+'}');
            });
            nextButton.click(() => {
                setDropDownValue(false, dropdown);
                this.logStat('NEXT_PERIOD {'+dropdown.getValue()+'}');
            });
        };

        generateInputUI();
        return container;
    }
}

export {SimplifiedFixedInnerDatePicker}